module.exports = __webpack_public_path__ + "static/media/brandLogo.cae6f510.png";